import {WidgetDetailedInfo} from "@wms/design-container";

export const layoutConfig: { [key: string]: WidgetDetailedInfo } = {
  'wm-column': {
    "widgetType": "wm-column",
    "template": "<wm-column></wm-column>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  "wm-page-content": {
    "widgetType": "wm-page-content",
    "template": "<wm-page-content></wm-page-content>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    tokenFileName: "page-content"
  },
  'wm-content': {
    "widgetType": "wm-content",
    "template": "<wm-content></wm-content>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-footer': {
    "widgetType": "wm-footer",
    "template": "<wm-footer></wm-footer>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    "isPageContainer": true, 
    "tokenFileName": "page-footer",
    styleWorkspaceTemplates: {
     customTemplate :[ `<wm-container style="background:#efefef"><wm-container name="HeaderContentFooter" class="app-outlined-container my-4" style="border: none;">
        <wm-layoutgrid name="layoutgrid30">
            <wm-gridrow name="gridrow122">
                <wm-gridcolumn name="gridcolumn290" class="col-sm-12 col-md-12">
                    <wm-container
                        class="global-overview-preview app-page container left-panel-collapsed-container app-nav-full slide-in-left-panel-container left-panel-container-md-10 left-panel-container-sm-10 left-panel-container-xs-2 app-outlined-container" style="background:#fff"
                        name="container1">
                        <div class="col-md-12 app-content clearfix">
                            <wm-container
                                class="app-header app-partial d-flex align-items-center justify-content-between"
                                name="container106" width="100%" height="64px" style="opacity:0.4">
                                <div class="header-left d-flex align-items-center">
                                    <wm-picture resizemode="cover" name="picture2" shape="circle" width="24.6"
                                        height="24.6" pictureplaceholder="resources/images/logos/favicon.ico">
                                    </wm-picture>
                                    <wm-label padding="unset" class="text-primary" type="p" name="label1"
                                        caption="Good morning John Smith"></wm-label>
                                </div>
                                <div class="header-right d-flex align-items-center">
                                    <div class="header-actions">
                                        <wm-icon name="icon3" iconclass="wm-sl-r sl-search"></wm-icon>
                                        <wm-icon name="icon4" iconclass="wm-sl-r sl-alarm-bell"></wm-icon>
                                    </div>
                                    <div class="header-account d-flex align-items-center">
                                        <wm-label padding="unset" class="p" type="p" name="label2" caption="John Smith">
                                        </wm-label>
                                        <wm-picture resizemode="cover" name="picture1" shape="circle" width="24.99"
                                            height="24.99"
                                            pictureplaceholder="resources/images/imagelists/login-bg.jpg"></wm-picture>
                                    </div>
                                </div>
                            </wm-container>
                            <wm-content name="content" height="500px" style="opacity:0.4">
                                <wm-page-content columnwidth="10" name="mainContent">
                                    <wm-container horizontalalign="center" name="container154" style="display: flex;justify-content: center;align-items: center;height: 100%">
                                        <wm-label padding="unset" class="h1" type="h1" caption="Page Content"
                                            name="label240"></wm-label>
                                    </wm-container>
                                </wm-page-content>
                            </wm-content>
                            <div class="app-footer clearfix" style="box-shadow: 0 0 15px rgb(112 158 208 / 80%); z-index: 10; position: relative;" name="container_1">
                                <wm-layoutgrid height="auto" name="footerlayout">
                                    <wm-gridrow name="footerrow">
                                        <wm-gridcolumn columnwidth="6" name="footerleft" verticalalign="bottom">
                                        </wm-gridcolumn>
                                        <wm-gridcolumn columnwidth="6" horizontalalign="right" verticalalign="bottom"
                                            name="footerright">
                                            <wm-label caption="Copyright 2026 [company name]" textalign="right"
                                                name="copyright"></wm-label>
                                        </wm-gridcolumn>
                                    </wm-gridrow>
                                </wm-layoutgrid>
                            </div>
                        </div>
                    </wm-container>
                </wm-gridcolumn>
            </wm-gridrow>
        </wm-layoutgrid>
    </wm-container></wm-container>`],
    "attributeObject" : {
      classTarget: "container_1"
    }
    }
  },
  'wm-header': {
    "widgetType": "wm-header",
    "template": "<wm-header></wm-header>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    "isPageContainer": true, 
    tokenFileName : "page-header", 
    styleWorkspaceTemplates: {
      customTemplate : [`<wm-container name="HeaderContentFooter" class="app-outlined-container my-4" style="background: #efefef; border:none">
      <wm-layoutgrid name="layoutgrid30">
          <wm-gridrow name="gridrow122">
              <wm-gridcolumn name="gridcolumn290" class="col-sm-12 col-md-12">
                  <wm-container
                      class="global-overview-preview app-page container left-panel-collapsed-container app-nav-full slide-in-left-panel-container left-panel-container-md-12 left-panel-container-sm-12 left-panel-container-xs-2 app-outlined-container"
                      name="container1" style="background: #fff;">
                      <div class="col-md-12 app-content clearfix">
                          <wm-container
                              class="app-header app-partial d-flex align-items-center justify-content-between"
                              name="container_1" width="100%" height="64px" style="box-shadow: 0 0 15px rgb(112 158 208 / 80%); z-index: 10; position: relative;">
                              <div class="header-left d-flex align-items-center">
                                  <wm-picture resizemode="cover" name="picture2" shape="circle" width="24.6"
                                      height="24.6" pictureplaceholder="resources/images/logos/favicon.ico">
                                  </wm-picture>
                                  <wm-label padding="unset" class="text-primary" type="p" name="label1"
                                      caption="Good morning John Smith"></wm-label>
                              </div>
                              <div class="header-right d-flex align-items-center">
                                  <div class="header-actions">
                                      <wm-icon name="icon3" iconclass="wm-sl-r sl-search"></wm-icon>
                                      <wm-icon name="icon4" iconclass="wm-sl-r sl-alarm-bell"></wm-icon>
                                  </div>
                                  <div class="header-account d-flex align-items-center">
                                      <wm-label padding="unset" class="p" type="p" name="label2" caption="John Smith">
                                      </wm-label>
                                      <wm-picture resizemode="cover" name="picture1" shape="circle" width="24.99"
                                          height="24.99"
                                          pictureplaceholder="resources/images/imagelists/login-bg.jpg"></wm-picture>
                                  </div>
                              </div>
                          </wm-container>
                          <wm-content name="content" style="opacity:0.4">
                              <wm-page-content columnwidth="12" name="mainContent">
                                  <wm-container horizontalalign="center" name="container154" style="display: flex;justify-content: center;align-items: center;height: 100%">
                                      <wm-label padding="unset" class="h1" type="h1" caption="Page Content"
                                          name="label240"></wm-label>
                                  </wm-container>
                              </wm-page-content>
                          </wm-content>
                          <div class="app-footer clearfix" style="opacity:0.4">
                              <wm-layoutgrid height="auto" name="footerlayout">
                                  <wm-gridrow name="footerrow">
                                      <wm-gridcolumn columnwidth="6" name="footerleft" verticalalign="bottom">
                                      </wm-gridcolumn>
                                      <wm-gridcolumn columnwidth="6" horizontalalign="right" verticalalign="bottom"
                                          name="footerright">
                                          <wm-label caption="Copyright 2026 [company name]" textalign="right"
                                              name="copyright"></wm-label>
                                      </wm-gridcolumn>
                                  </wm-gridrow>
                              </wm-layoutgrid>
                          </div>
                      </div>
                  </wm-container>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-layoutgrid>
  </wm-container>`],
      attributeObject : {
        "classTarget" : "container_1"
      }
    }
  },
  'wm-left-panel': {
    "widgetType": "wm-left-panel",
    "template": "<wm-left-panel></wm-left-panel>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    "isPageContainer": true, 
    "tokenFileName": "page-left-nav",
    styleWorkspaceTemplates: {
      customTemplate: [`<wm-container name="HeaderleftnavRailClippedContent" class="app-outlined-container my-4"
      style="border:none">
      <wm-layoutgrid name="layoutgrid2_1">
          <wm-gridrow name="gridrow2">
              <wm-gridcolumn name="gridcolumn3" class="col-sm-12 col-md-12">
                  <wm-container class="global-overview-preview app-outlined-container" name="container1" style="background:#fff">
                      <wm-container
                          class="app-header app-partial d-flex align-items-center justify-content-between"
                          name="container42" width="100%" style="opacity:0.4;">
                          <div class="header-left d-flex align-items-center">
                              <wm-picture resizemode="cover" name="picture2" shape="circle" width="24.6"
                                  height="24.6" pictureplaceholder="resources/images/logos/favicon.ico">
                              </wm-picture>
                              <wm-label padding="unset" class="text-primary" type="p" name="label1"
                                  caption="Good morning John Smith"></wm-label>
                          </div>
                          <div class="header-right d-flex align-items-center">
                              <div class="header-actions">
                                  <wm-icon name="icon3" iconclass="wm-sl-r sl-search"></wm-icon>
                                  <wm-icon name="icon4" iconclass="wm-sl-r sl-alarm-bell"></wm-icon>
                              </div>
                              <div class="header-account d-flex align-items-center">
                                  <wm-label padding="unset" class="p" type="p" name="label2"
                                      caption="John Smith">
                                  </wm-label>
                                  <wm-picture resizemode="cover" name="picture1" shape="circle"
                                      width="24.99" height="24.99"
                                      pictureplaceholder="resources/images/imagelists/login-bg.jpg">
                                  </wm-picture>
                              </div>
                          </div>
                      </wm-container>
                      <wm-content name="content">
                          <aside
                              class="left-panel-collapsed col-md-2 col-sm-2 left-panel-collapsed col-md-2 col-sm-2 col-xs-10 slide-in app-left-panel" style="box-shadow: 0 0 15px rgb(112 158 208 / 80%); z-index: 10;position: relative;" name="container_1">
                              <wm-nav name="leftnavigation" type="pills" layout="stacked">
                                  <wm-nav-item name="list_Main">
                                      <wm-anchor caption="Main" name="MainLink"
                                          iconclass="wi wi-bar-graph">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_PageLayout">
                                      <wm-anchor caption="PageLayouts" name="PageLayoutLink"
                                          iconclass="wi wi-file" conditionalclass="active"></wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Form">
                                      <wm-anchor caption="Form" name="FormLink" iconclass="wi wi-tag"
                                          badgevalue="10">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Basic">
                                      <wm-anchor caption="Basic" name="BasicLink"
                                          iconclass="wi wi-envelope" iconposition="left"></wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Data">
                                      <wm-anchor caption="Data" name="DataLink"
                                          iconclass="wi wi-database">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Container">
                                      <wm-anchor caption="Container" name="ContainerLink"
                                          iconclass="wi wi-layout">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Charts">
                                      <wm-anchor caption="Charts" name="ChartsLink"
                                          iconclass="wi wi-bar-chart">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Navigation">
                                      <wm-anchor caption="Navigation" name="NavigationLink"
                                          iconclass="wi wi-widgets">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Advanced">
                                      <wm-anchor caption="Advanced" name="AdvancedLink"
                                          iconclass="wi wi-markunread-mailbox"></wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Dialog">
                                      <wm-anchor caption="Dialog" name="DialogLink"
                                          iconclass="wi wi-filter-frames">
                                      </wm-anchor>
                                  </wm-nav-item>
                                  <wm-nav-item name="list_Wizards">
                                      <wm-anchor caption="Wizards" name="WizardsLink"
                                          iconclass="wi wi-more-horiz">
                                      </wm-anchor>
                                  </wm-nav-item>
                              </wm-nav>
                          </aside>
                          <wm-page-content columnwidth="10" name="mainContent">
                              <wm-container horizontalalign="center" name="container158"
                                  style="display: flex;justify-content: center;align-items: center;height: 100%; opacity:0.4">
                                  <wm-label padding="unset" class="h1" type="h1" caption="Page Content"
                                      name="label244"></wm-label>
                              </wm-container>
                          </wm-page-content>
                      </wm-content>
                  </wm-container>
              </wm-gridcolumn>
          </wm-gridrow>
      </wm-layoutgrid>
  </wm-container>`], 
      attributeObject: {

          "classTarget" : "container_1", 

      }, 
      platforms: {
        native_mobile: {
          customTemplate: [`<div style="padding-bottom: 120px;" class="app-left-panel" type="left-panel">
  <wm-nav type="pills" layout="stacked" name="nav1">
    <wm-nav-item name="nav_item1">
      <wm-anchor caption="New Post" iconclass="wi wi-plus" name="anchor1"></wm-anchor>
    </wm-nav-item>
    <wm-nav-item name="nav_item2">
      <wm-anchor caption="Bookmark" iconclass="wi wi-bookmark" name="anchor2"></wm-anchor>
    </wm-nav-item>
    <wm-nav-item name="nav_item3">
      <wm-anchor caption="Official Twitter" iconclass="wi wi-bookmark" name="anchor3"></wm-anchor>
    </wm-nav-item>
  </wm-nav>
  <wm-nav type="pills" layout="stacked" name="nav2">
    <wm-nav-item name="nav_item4">
      <wm-anchor caption="Settings" name="anchor4" badgevalue="4"></wm-anchor>
    </wm-nav-item>
    <wm-nav-item name="nav_item5">
      <wm-anchor caption="Help" name="anchor5"></wm-anchor>
    </wm-nav-item>
    <wm-nav-item name="nav_item6">
      <wm-anchor caption="Send Feedback" name="anchor6"></wm-anchor>
    </wm-nav-item>
  </wm-nav>
</div>`]
        }
      }
    }
  },
  'wm-page': {
    "widgetType": "wm-page",
    "template": "<wm-page></wm-page>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-partial': {
    "widgetType": "wm-partial",
    "template": "<wm-partial></wm-partial>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-prefab-container': {
    "widgetType": "wm-prefab-container",
    "template": "<wm-prefab-container></wm-prefab-container>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-custom-widget': {
      "widgetType": "wm-custom-widget",
      "template": "<wm-custom-widget></wm-custom-widget>",
      "isContainer": false,
      "isResizable": true,
      "isMovableInsideCanvas": true,
      "isDroppable": false,
      "isDeletable": true,
      "canBeCopied": false,
      "isLayoutBundled": true
  },
  'wm-right-panel': {
    "widgetType": "wm-right-panel",
    "template": "<wm-right-panel></wm-right-panel>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false,
    "isPageContainer": true, 
    "tokenFileName": "page-right-nav",
    styleWorkspaceTemplates: {
      customTemplate: [
        `<wm-container style="background:#efefef">
                <wm-container name="HeaderleftnavContentRightNav" class="app-outlined-container my-4" style="border: none;">
                    <wm-layoutgrid name="layoutgrid2_1">
                        <wm-gridrow name="gridrow2">
                            <wm-gridcolumn name="gridcolumn3" class="col-sm-12 col-md-12">
                                <wm-container class="global-overview-preview app-outlined-container" name="container1" style="background:#fff">
                                    <wm-container
                                        class="app-header app-partial d-flex align-items-center justify-content-between"
                                        name="container138" width="100%" style="opacity: 0.4">
                                        <div class="header-left d-flex align-items-center">
                                            <wm-picture resizemode="cover" name="picture2" shape="circle" width="24.6"
                                                height="24.6" pictureplaceholder="resources/images/logos/favicon.ico">
                                            </wm-picture>
                                            <wm-label padding="unset" class="text-primary" type="p" name="label1"
                                                caption="Good morning John Smith"></wm-label>
                                        </div>
                                        <div class="header-right d-flex align-items-center">
                                            <div class="header-actions">
                                                <wm-icon name="icon3" iconclass="wm-sl-r sl-search"></wm-icon>
                                                <wm-icon name="icon4" iconclass="wm-sl-r sl-alarm-bell"></wm-icon>
                                            </div>
                                            <div class="header-account d-flex align-items-center">
                                                <wm-label padding="unset" class="p" type="p" name="label2"
                                                    caption="John Smith">
                                                </wm-label>
                                                <wm-picture resizemode="cover" name="picture1" shape="circle"
                                                    width="24.99" height="24.99"
                                                    pictureplaceholder="resources/images/imagelists/login-bg.jpg">
                                                </wm-picture>
                                            </div>
                                        </div>
                                    </wm-container>
                                    <wm-content name="content">
                                        <aside
                                            class="left-panel-collapsed col-md-2 col-sm-2 left-panel-collapsed col-md-2 col-sm-2 col-xs-10 slide-in app-nav-drawer app-nav-clipped app-left-panel">
                                            <wm-nav name="leftnavigation" type="pills" layout="stacked" style="opacity:0.4">
                                                <wm-nav-item name="list_Main">
                                                    <wm-anchor caption="Main" name="MainLink"
                                                        iconclass="wi wi-bar-graph">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_PageLayout">
                                                    <wm-anchor caption="PageLayouts" name="PageLayoutLink"
                                                        iconclass="wi wi-file" conditionalclass="active"></wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Form">
                                                    <wm-anchor caption="Form" name="FormLink" iconclass="wi wi-tag"
                                                        badgevalue="10">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Basic">
                                                    <wm-anchor caption="Basic" name="BasicLink"
                                                        iconclass="wi wi-envelope" iconposition="left"></wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Data">
                                                    <wm-anchor caption="Data" name="DataLink"
                                                        iconclass="wi wi-database">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Container">
                                                    <wm-anchor caption="Container" name="ContainerLink"
                                                        iconclass="wi wi-layout">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Charts">
                                                    <wm-anchor caption="Charts" name="ChartsLink"
                                                        iconclass="wi wi-bar-chart">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Navigation">
                                                    <wm-anchor caption="Navigation" name="NavigationLink"
                                                        iconclass="wi wi-widgets">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Advanced">
                                                    <wm-anchor caption="Advanced" name="AdvancedLink"
                                                        iconclass="wi wi-markunread-mailbox"></wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Dialog">
                                                    <wm-anchor caption="Dialog" name="DialogLink"
                                                        iconclass="wi wi-filter-frames">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_Wizards">
                                                    <wm-anchor caption="Wizards" name="WizardsLink"
                                                        iconclass="wi wi-more-horiz">
                                                    </wm-anchor>
                                                </wm-nav-item>
                                            </wm-nav>
                                        </aside>
                                        <wm-page-content columnwidth="8" name="mainContent">
                                            <wm-container name="container152" horizontalalign="center"
                                                style="display: flex;justify-content: center;align-items: center;height: 100%; opacity: 0.4">
                                                <wm-label padding="unset" class="h1" type="h1" name="label236"
                                                    caption="Page Content"></wm-label>
                                            </wm-container>
                                        </wm-page-content>
                                        <aside class="app-right-panel col-sm-2 col-md-2" style="box-shadow: 0 0 15px rgb(112 158 208 / 80%); z-index: 10;position: relative;" name="container_1">
                                            <wm-nav name="rightnav" type="pills" layout="stacked">
                                                <wm-nav-item name="list_task">
                                                    <wm-anchor caption="Tasks" name="taskLink"></wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_directory">
                                                    <wm-anchor caption="Teams" name="teamsLink"></wm-anchor>
                                                </wm-nav-item>
                                                <wm-nav-item name="list_people">
                                                    <wm-anchor caption="People" name="peopleLink"></wm-anchor>
                                                </wm-nav-item>
                                            </wm-nav>
                                        </aside>
                                    </wm-content>
                                </wm-container>
                            </wm-gridcolumn>
                        </wm-gridrow>
                    </wm-layoutgrid>
                </wm-container>
            </wm-container>`
      ], 
      "attributeObject" : {
        classTarget : "container_1"
      }
    }
  },
  'wm-row': {
    "widgetType": "wm-row",
    "template": "<wm-row></wm-row>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  },
  'wm-top-nav': {
    "widgetType": "wm-top-nav",
    "template": "<wm-top-nav></wm-top-nav>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": false,
    "canBeCopied": false,
    "isPageContainer": true,
    "tokenFileName": "page-top-nav",
    styleWorkspaceTemplates: {
      customTemplate: [
        `
        <wm-container name="HeaderTopNavContentFooter" class="app-outlined-container my-4" style="background: #efefef; border:none">
        <wm-layoutgrid name="layoutgrid35">
            <wm-gridrow name="gridrow140">
                <wm-gridcolumn name="gridcolumn333" class="col-sm-12 col-md-12">
                    <wm-container
                        class="global-overview-preview app-page container left-panel-collapsed-container app-nav-full slide-in-left-panel-container left-panel-container-md-10 left-panel-container-sm-10 left-panel-container-xs-2 app-outlined-container" style="background: #fff;"
                        name="container1">
                        <div class="col-md-12 app-content clearfix">
                            <wm-container
                                class="app-header app-partial d-flex align-items-center justify-content-between"
                                name="container122" width="100%" height="64px" style="opacity:0.4">
                                <div class="header-left d-flex align-items-center">
                                    <wm-picture resizemode="cover" name="picture2" shape="circle" width="24.6"
                                        height="24.6" pictureplaceholder="resources/images/logos/favicon.ico">
                                    </wm-picture>
                                    <wm-label padding="unset" class="text-primary" type="p" name="label1"
                                        caption="Good morning John Smith"></wm-label>
                                </div>
                                <div class="header-right d-flex align-items-center">
                                    <div class="header-actions">
                                        <wm-icon name="icon3" iconclass="wm-sl-r sl-search"></wm-icon>
                                        <wm-icon name="icon4" iconclass="wm-sl-r sl-alarm-bell"></wm-icon>
                                    </div>
                                    <div class="header-account d-flex align-items-center">
                                        <wm-label padding="unset" class="p" type="p" name="label2" caption="John Smith">
                                        </wm-label>
                                        <wm-picture resizemode="cover" name="picture1" shape="circle" width="24.99"
                                            height="24.99"
                                            pictureplaceholder="resources/images/imagelists/login-bg.jpg"></wm-picture>
                                    </div>
                                </div>
                            </wm-container>
                            <div class="app-top-nav" style="box-shadow: 0 0 15px rgb(112 158 208 / 80%); z-index: 10; position: relative;" name="container_1">
                                <wm-navbar name="navbar5">
                                    <wm-nav name="leftTopLinks" type="navbar" class="navbar-left">
                                        <wm-nav-item name="list_home">
                                            <wm-anchor caption="Home" name="homeLink" iconclass="wi wi-home">
                                            </wm-anchor>
                                        </wm-nav-item>
                                        <wm-nav-item name="list_services">
                                            <wm-anchor caption="Order" name="orderLink" iconclass="wi wi-list">
                                            </wm-anchor>
                                        </wm-nav-item>
                                    </wm-nav>
                                    <wm-nav name="rightTopLinks" type="navbar" class="navbar-right">
                                        <wm-nav-item name="list_help">
                                            <wm-anchor caption="Help" name="helpLink" iconclass="wi wi-help-outline">
                                            </wm-anchor>
                                        </wm-nav-item>
                                        <wm-nav-item name="list_logout">
                                            <wm-anchor caption="Logout" name="logoutLink" iconclass="wi wi-sign-out">
                                            </wm-anchor>
                                        </wm-nav-item>
                                    </wm-nav>
                                </wm-navbar>
                            </div>
                            <wm-content name="content" height="500px" style="opacity:0.4">
                                <wm-page-content columnwidth="10" name="mainContent">
                                    <wm-container name="container153" horizontalalign="center" style="display: flex;justify-content: center;align-items: center;height: 100%">
                                        <wm-label padding="unset" class="h1" type="h1" caption="Page Content"
                                            name="label238"></wm-label>
                                    </wm-container>
                                </wm-page-content>
                            </wm-content>
                            <div class="app-footer clearfix" style="opacity:0.4">
                                <wm-layoutgrid height="auto" name="footerlayout">
                                    <wm-gridrow name="footerrow">
                                        <wm-gridcolumn columnwidth="6" name="footerleft" verticalalign="bottom">
                                        </wm-gridcolumn>
                                        <wm-gridcolumn columnwidth="6" horizontalalign="right" verticalalign="bottom"
                                            name="footerright">
                                            <wm-label caption="Copyright 2026 [company name]" textalign="right"
                                                name="copyright"></wm-label>
                                        </wm-gridcolumn>
                                    </wm-gridrow>
                                </wm-layoutgrid>
                            </div>
                        </div>
                    </wm-container>
                </wm-gridcolumn>
            </wm-gridrow>
        </wm-layoutgrid>
    </wm-container>`
      ], 
      "attributeObject" : {
        "classTarget" : "container_1"
      }
    }
  },
  'wm-view': {
    "widgetType": "wm-view",
    "template": "<wm-view></wm-view>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": false,
    "isDeletable": true,
    "canBeCopied": false
  },
  'wm-template': {
    "widgetType": "wm-template",
    "template": "<wm-template></wm-template>",
    "isContainer": true,
    "isResizable": false,
    "isMovableInsideCanvas": false,
    "isDroppable": true,
    "isDeletable": false,
    "canBeCopied": false
  }
}



